"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionCallback = void 0;
const React = __importStar(require("react"));
const __1 = require("..");
/**
 * A hook that can listen for one or more redux actions being dispatched into the store, and perform
 * a callback when they are.
 * @param callback The callback to perform. This will be called with the invoked action.
 * @param actions The action or actions to listen for.
 */
const useActionCallback = (callback, ...actions) => {
    const { registerActionListener, deregisterActionListener } = React.useContext(__1.AppContext);
    React.useEffect(() => {
        // Map each action listener key to its action
        const actionMapping = {};
        actions.forEach((a) => {
            const key = Math.random().toString(36);
            registerActionListener(key, a, callback);
            actionMapping[key] = a;
        });
        return () => {
            Object.entries(actionMapping).forEach(([key, act]) => deregisterActionListener(key, act));
        };
    }, []);
};
exports.useActionCallback = useActionCallback;
//# sourceMappingURL=actionCallback.js.map